import Home from './Home.data-manager-geo-list.vue'

export default {
    Home
}